module.exports = __webpack_public_path__ + "img/banner6.50f579f5.png";